import React from 'react'
import Button from '@mui/material/Button'
import DeleteIcon from '@mui/icons-material/Delete'
import { useDispatch, useSelector } from 'react-redux'
import { deleteProject, deleteScenario } from '../../actions'

export default function Delete() {
  const dispatch = useDispatch()
  const { selectedProjectId, selectedScenarioId } = useSelector(state => state)

  const itemToDelete = selectedScenarioId ? 'Scenario' : 'Project'

  const click = () => {
    // eslint-disable-next-line no-undef
    const ok = window.confirm(
      `Are you sure you want to delete this ${itemToDelete}?`
    )
    if (ok) {
      if (itemToDelete === 'Scenario') {
        dispatch(deleteScenario(selectedScenarioId))
      } else {
        dispatch(deleteProject(selectedProjectId))
      }
    }
  }

  return (
    <Button className="delete-icon" onClick={click}>
      <DeleteIcon style={{ color: 'white' }} />
    </Button>
  )
}
